import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss']
})
export class OrderConfirmationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OrderConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }
  orderNr: any;

  closeModal() {
    this.dialogRef.close();
  }


  ngOnInit(): void {
    this.orderNr = this.modalData.orderNr? this.modalData.orderNr : '-';
  }

}
